const createUserDialog = {
  title: "Stofna nýjan notanda",
  labels: {
    email: "Netfang *",
    fullName: "Fullt nafn *",
    institution: "Stofnun *",
    password: "Lykilorð *",
    confirmPassword: "Staðfesta lykilorð *",
    role: "Hlutverk",
  },
  roles: {
    researcher: "Rannsakandi",
    pi: "Ábyrgðarmaður (PI)",
    manager: "Stjórnandi",
    dataUploader: "Gagnahleðari",
  },
  errors: {
    allFieldsRequired: "Öll svæði eru nauðsynleg",
    passwordMismatch: "Lykilorð stemma ekki",
    passwordTooShort: "Lykilorð verður að vera að minnsta kosti 8 stafir",
    createFailed: "Ekki tókst að stofna notanda",
  },
  creating: "Stofna...",
  createButton: "Stofna notanda",
};

export default createUserDialog;
